import React, { useState } from "react";

function QuizModal({ quizzes, onClose }) {
  const [index, setIndex] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);

  const q = quizzes[index];

  const options = [
    { text: q.option1, correct: q.option1_correct },
    { text: q.option2, correct: q.option2_correct },
    { text: q.option3, correct: q.option3_correct },
    { text: q.option4, correct: q.option4_correct },
  ];

  const submitAnswer = () => {
    if (selected === null) return;

    if (options[selected].correct) {
      setScore(score + 1);
    }

    if (index + 1 < quizzes.length) {
      setIndex(index + 1);
      setSelected(null);
    } else {
      setFinished(true);
    }
  };

  return (
    <div className="quiz-backdrop">
      <div className="quiz-modal">

        {/* Top Close Button */}
        <button className="quiz-close-btn" onClick={onClose}>✖</button>

        {!finished ? (
          <>
            {/* Question */}
            <h4 className="fw-bold mb-3">
              Question {index + 1}/{quizzes.length}
            </h4>

            <div
              className="mb-3"
              dangerouslySetInnerHTML={{ __html: q.question_text }}
            />

            {/* Options */}
            <div className="d-flex flex-column gap-2">
              {options.map((opt, i) => (
                <div
                  key={i}
                  className={`quiz-option ${selected === i ? "active" : ""}`}
                  onClick={() => setSelected(i)}
                >
                  {opt.text}
                </div>
              ))}
            </div>

            {/* Submit Button */}
            <button 
              className="btn btn-primary w-100 mt-4"
              disabled={selected === null}
              onClick={submitAnswer}
            >
              {index + 1 === quizzes.length ? "Finish" : "Next"}
            </button>
          </>
        ) : (
          <>
            <h3 className="text-center fw-bold mb-3">Quiz Completed 🎉</h3>
            <h4 className="text-center">Your Score:</h4>

            <h2 className="text-center text-success fw-bold">
              {score} / {quizzes.length}
            </h2>

            <button 
              className="btn btn-dark w-100 mt-4"
              onClick={onClose}
            >
              Close
            </button>
          </>
        )}

      </div>

      {/* Styles */}
      <style>{`
        .quiz-backdrop {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .quiz-modal {
          width: 90%;
          max-width: 500px;
          background: #fff;
          padding: 25px;
          border-radius: 12px;
          position: relative;
          animation: fadeIn 0.2s ease;
        }

        .quiz-close-btn {
          position: absolute;
          top: 10px;
          right: 10px;
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
        }

        .quiz-option {
          padding: 12px 15px;
          border-radius: 8px;
          border: 1px solid #ccc;
          cursor: pointer;
          transition: 0.2s;
        }

        .quiz-option.active {
          background: #007bff;
          color: white;
          border-color: #007bff;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

export default QuizModal;
